import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Buefy from 'buefy';
import Vuelidate from 'vuelidate';
import i18n from './i18n';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import VueCarousel from 'vue-carousel';
import VueLineClamp from 'vue-line-clamp';
import moment from 'moment';
import 'moment/locale/ja';
import { truncateFilter } from './utils/filterUtil';

Vue.prototype.$moment = moment;

library.add(faCoffee);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Buefy);
Vue.use(Vuelidate);
Vue.use(VueCarousel);
Vue.use(VueLineClamp, {
  importCss: true
});

// Add filter
Vue.filter('truncate', truncateFilter);

Vue.prototype.$appName = process.env.VUE_APP_NAME || 'Reptop';
Vue.prototype.$hideDemoBar = false;
Vue.prototype.$txHashUrl = 'https://ropsten.etherscan.io/tx/';

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

window['vue'] = app;
window.store = store;
